export default __webpack_public_path__ + "static/media/heliopolis.511cb211.jpg";